import { useState } from "react";
import useFetchData from "../../hooks/useFetchData";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import Button from "../../components/FormComponents/Button";

const CreateSubformModal = ({ create }) => {
  const { data, loading, error } = useFetchData("/state-machines");
  const [selectedType, setSelectedType] = useState("");
  const [allTables, setAllTables] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [creationData, setCreationData] = useState({
    name: "",
    config: {
      fields: [],
      settings: {
        allow_add: [],
        allow_delete: []
      },
      table_id: ""
    }
  });

  const handelTypeChange = (e) => {
    const { value } = e.target;
    const smType = value === "statemachine" ? "default" : "entity";
    setSelectedType(value);
    setAllTables(data.filter((table) => table.sm_type === smType));
  };
  const addSubform = async () => {
    setIsLoading(true);
    await create(creationData);
    setIsLoading(false);
  };
  if (loading) {
    return <div>loading...</div>;
  }
  if (error) {
    return <div>{error.message}</div>;
  }
  return (
    <>
      <div className="builder_form">
        <Input
          label="Subform Name"
          name="name"
          value={creationData.name}
          onChange={(e) => setCreationData({ ...creationData, name: e.target.value })}
        />
      </div>
      <div className=" form_element_wrapper_text  ">
        <label className="builder_label ">Choose type</label>
        <div className="blocks_type_radio ">
          <label className="builder_label " style={{ display: "flex", margin: "0px", alignItems: "center", gap: "0" }}>
            <Input
              type="radio"
              name="type"
              value="entity"
              checked={selectedType === "entity"}
              onChange={handelTypeChange}
            />
            entity
          </label>
          <label className="builder_label" style={{ display: "flex", margin: "0px", gap: 0, alignItems: "center" }}>
            <Input
              type="radio"
              name="type"
              value="statemachine"
              checked={selectedType === "statemachine"}
              onChange={handelTypeChange}
            />
            statemachine
          </label>
        </div>
      </div>

      {selectedType && (
        <>
          <div className="builder_form">
            <SingleSelectBox
              selectedData={creationData.config.table_id}
              options={allTables}
              onChange={(obj) => setCreationData({ ...creationData, config: { fields: [], table_id: obj.id } })}
              placeholder="Select Table"
              label="Select Table"
            />
            {creationData.config.table_id && (
              <Button isLoading={isLoading} onClick={addSubform}>
                Add +
              </Button>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default CreateSubformModal;
